const STORAGE_KEY = "sharedLists";

const safeParse = (value) => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.warn("sharedListServices: parse failed", err);
    return [];
  }
};

const normalizeEntry = (entry) => {
  if (!entry || !entry.ownerKey || !entry.key || !entry.idList) return null;
  return {
    ownerKey: String(entry.ownerKey),
    ownerName: entry.ownerName ? String(entry.ownerName) : "",
    key: String(entry.key),
    idList: String(entry.idList),
    name: entry.name ? String(entry.name) : "",
    url: entry.url ? String(entry.url) : "",
    addedAt: entry.addedAt || new Date().toISOString(),
  };
};

class SharedListServices {
  getAll() {
    return safeParse(localStorage.getItem(STORAGE_KEY));
  }

  getAllForOwner(ownerKey) {
    if (!ownerKey) return [];
    return this.getAll().filter((entry) => entry.ownerKey === String(ownerKey));
  }

  buildUrl(sharedKey, idList) {
    if (!sharedKey) return "/";
    const base = window.location.origin;
    const shouldIncludeId = idList && idList !== "all";
    const idParam = shouldIncludeId ? `&idList=${encodeURIComponent(idList)}` : "";
    return `${base}/?key=${encodeURIComponent(sharedKey)}${idParam}`;
  }

  isSaved(ownerKey, sharedKey, idList) {
    if (!ownerKey || !sharedKey || !idList) return false;
    const all = this.getAllForOwner(ownerKey);
    return all.some(
      (entry) => entry.key === String(sharedKey) && entry.idList === String(idList)
    );
  }

  add(entry) {
    const normalized = normalizeEntry(entry);
    if (!normalized) return this.getAll();
    const all = this.getAll();
    const exists = all.some(
      (item) =>
        item.ownerKey === normalized.ownerKey &&
        item.key === normalized.key &&
        item.idList === normalized.idList
    );
    if (!exists) {
      all.push(normalized);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    }
    return all;
  }

  remove(ownerKey, sharedKey, idList) {
    if (!ownerKey || !sharedKey || !idList) return this.getAll();
    const next = this.getAll().filter(
      (entry) =>
        !(
          entry.ownerKey === String(ownerKey) &&
          entry.key === String(sharedKey) &&
          entry.idList === String(idList)
        )
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  }
}

export default new SharedListServices();
